angular.module('pulseApp').config(function($stateProvider, $urlRouterProvider) {
    
    $stateProvider.state('provider', {
        url: '/provider/:id',
        controller: 'ProviderCtrl as vm',
        templateUrl: 'app/view/provider/provider.html',
    });    

}).controller('ProviderCtrl', function ($scope, $state, $stateParams,$location, $anchorScroll, $firebaseObject) {
    var vm = this;
    vm.id = $stateParams.id;

    var ref = firebase.database().ref('Providers').child(vm.id);
    // download the data into a local object
    vm.data = $firebaseObject(ref);
	vm.data.$loaded()
    .then(function(x) {
       
            if(vm.data.Reviews !== undefined && vm.data.Reviews !== null){
                vm.data.ReviewCount = Object.keys(vm.data.Reviews).length;
                vm.data.totalRating = 0;
                var type = _.find(vm.nameTypes, {'abbr': vm.data.Type});
                if(type !== undefined && type !== null){
                    vm.data.TypeName = type.name;  
                }
                                for(var key in vm.data.Reviews) {
                    var value = vm.data.Reviews[key];
                    vm.data.totalRating = vm.data.totalRating + value.Stars;
                    // do something with "key" and "value" variables
                  }
                   vm.data.avgRating = vm.data.totalRating /vm.data.ReviewCount;
                }
            else{
                vm.data.ReviewCount = 0;
            }
    })
    .catch(function(error) {
      console.log("Error:", error);
    });

    vm.helpful = function(review){
        review.ReviewHelpCount = review.ReviewHelpCount + 1;
        vm.data.$save();
    };

    

    vm.nameTypes  = [{
        abbr: 'F',
        name: 'Food'
    },
    {
        abbr: 'H',
        name: 'Housing'
    },
    {
        abbr: 'G',
        name: 'Government Services'
    },
    {
        abbr: 'E',
        name: 'Events'
    },
    {
        abbr: 'HE',
        name: 'Health'
    },
    {
        abbr: 'W',
        name: 'Work'
    },
    
    ]
    
    
    vm.scrollToReviews = function(){
        $location.hash('listing-reviews');
        $anchorScroll();
    }
    vm.toggleBounce = function() {
        if (this.getAnimation() != null) {
          this.setAnimation(null);
        } else {
          this.setAnimation(google.maps.Animation.BOUNCE);
        }
      }
    var destroy = $scope.$on("$destroy", function () {
        //Cleanup anything that would persist beyond destruction, including $on/$watch
        destroy();
    });
});